import axios from '@/utils/axios';

export default {
  getDetect() {
    return axios.get(`/detect-fields`,);
  },
  getDetectBox(data) {
    return axios.post(`/template/${data.id}/auto-detect`, {'fields': data.fields});
  },
};
